import clsx from "clsx";
import React from "react";
import { IconButton } from "nvs-design-system/dist/IconButton";
import { IconButtonType } from "nvs-design-system/dist/IconButton/types";
import { Close } from "nvs-ds-icons/react/navigation";
import { Title4 } from "../typography/components/Title";

type Props = React.PropsWithChildren<{
  onClose: () => void;
  classes?: {
    outerDiv?: string;
    title?: string;
    icon?: string;
  };
}>;

export const MarketplaceModalHeader: React.FC<Props> = ({
  onClose,
  children,
  classes,
}) => {
  return (
    <div
      className={clsx(
        "dark relative mb-4 flex min-h-[24px] w-full justify-between text-white",
        classes?.outerDiv,
      )}
    >
      {children && <Title4 className={classes?.title}>{children}</Title4>}
      <IconButton
        buttonType={IconButtonType.no_outline}
        onClick={() => onClose()}
        aria-label={"Close Modal"}
        className={classes?.icon}
      >
        <Close />
      </IconButton>
    </div>
  );
};
